import { Pipe, PipeTransform } from '@angular/core';
import { OrderableQualifier, OrderedIngredient } from 'ngx-web-api';

@Pipe({
  name: 'qualifierIsOrdered',
})
export class QualifierIsOrderedPipe implements PipeTransform {
  transform(orderedIngredient: OrderedIngredient, qualifier: OrderableQualifier): boolean {
    if (!!orderedIngredient && !!qualifier) {
      return (orderedIngredient.qualifiers || []).some(q => q === qualifier.name);
    }
    return false;
  }
}
